module.exports = __webpack_public_path__ + "static/media/featurecheck.6f18a632.svg";